import { Button, Col, Icon, Row } from 'antd';
import { TeamTree } from 'components/page/index';
import { SearchPool } from 'components/ui/index';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import {
  setActiveTeam,
  addTeamToShared,
  addUserToShared
} from '../flow/actions';

const defaultProps = {
  setActiveTeam: null
};
const propTypes = {
  setActiveTeam: PropTypes.func,
  teams: PropTypes.array.isRequired,
  teammembers: PropTypes.array.isRequired
};

class SharedToUsersAndTeams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true
    };
  }

  handleBtnClick = () =>
    this.setState(state => ({
      collapsed: !state.collapsed
    }));
  handleTeamClick = id => this.props.setActiveTeam(Number(id));
  handleTeamDbClick = id => {
    const team = this.props.flatTeams.find(ft => ft.id === id);
    if (team) {
      this.props.addTeamToShared(team);
    }
  };
  handleUserDbClick = id => {
    const user = this.props.teammembers.find(tm => tm.id === id);
    if (user) {
      this.props.addUserToShared(user);
    }
  };

  render() {
    const { collapsed } = this.state;
    const { teams, teammembers } = this.props;
    return (
      <Fragment>
        <Button size="small" className="ml-sm" onClick={this.handleBtnClick}>
          <FormattedMessage id="page.Section_SharedTo.buttonTeams" />
          <Icon
            className="font-sm"
            type={collapsed ? 'caret-down' : 'caret-up'}
          />
        </Button>
        {!collapsed && (
          <Row className="mt-md">
            <Col span={8}>
              <TeamTree
                teams={teams}
                onSelect={this.handleTeamClick}
                onDbClick={this.handleTeamDbClick}
              />
            </Col>
            <Col span={16}>
              <SearchPool
                users={teammembers}
                onTagDoubleClick={this.handleUserDbClick}
              />
            </Col>
          </Row>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ global, sharableObjects }) => {
  const { flatTeams, teams, users } = sharableObjects;
  const activeTeam = flatTeams.find(ft => ft.isActive);
  const activeTeamId = activeTeam ? activeTeam.id : null;
  const teammembers = users.filter(u => u.teamId === activeTeamId);
  return {
    lang: global.language,
    teams,
    flatTeams,
    teammembers
  };
};
const mapDispatchToProps = {
  setActiveTeam,
  addTeamToShared,
  addUserToShared
};
SharedToUsersAndTeams.defaultProps = defaultProps;
SharedToUsersAndTeams.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SharedToUsersAndTeams);



// WEBPACK FOOTER //
// ./src/views/Section_SharedTo/components/SharedToUsersAndTeams.jsx